import { jsx as _jsx } from "react/jsx-runtime";
import { WarningBadge } from '@common/badge';
export function ConfigurationBadge(props) {
    return _jsx(WarningBadge, { ...props, children: "Configuration required" });
}
